import { render, staticRenderFns } from "./PrivacyPortalCategoryExternal.vue?vue&type=template&id=8a927e70&scoped=true"
import script from "./PrivacyPortalCategoryExternal.vue?vue&type=script&lang=js"
export * from "./PrivacyPortalCategoryExternal.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPortalCategoryExternal.vue?vue&type=style&index=0&id=8a927e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a927e70",
  null
  
)

export default component.exports